import CircleProgress from './CircleProgress.component';

export default CircleProgress;